// jobs container directive
finderApp.directive('jobsContainer', function (finderBasePath) {
    return {
        restrict: 'E',
        templateUrl: finderBasePath + 'template/jobsContainer.html'
    }
});